import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from '../pages/Main.vue'
import EnMain from '../pages/en/Main.vue'
// 科学数据
import SearchList from "../pages/search/search"
import SearchEnList from "../pages/en/search/search"
import Details from "../pages/search/detail"
import EnDetails from "../pages/en/search/detail"

import NsfList from "../pages/search/research"
import NsfEnList from "../pages/en/search/research"

// 预印本
import Priprent from "../pages/search/preprint"
import EnPriprent from "../pages/en/search/preprint"
import priprentDetailEn from "../pages/search/priprentDetail"
import priprentDetail from "../pages/en/search/priprentDetail"
// 来源国
import country from "../pages/search/country"
//设备
import instrument from "../pages/search/instrument"
import enInstrument from "../pages/en/search/instrument"
// 成果
import NewList from "../pages/search/news/works"
// 学术论文
import Paper from "../pages/search/paper"
import PaperEn from "../pages/en/search/paper"
import paperDetail from "../pages/search/paperDetail"
import paperDetailEn from "../pages/en/search/paperDetail"

// 学位论文
import priList from "../pages/search/priList"
import SearchEnPrilist from "../pages/en/search/priList"
// 详情 dissDetail

// 重大基础设施
import facilities from "../pages/search/facilities"
import enFacilities from "../pages/en/search/facilities"

// 物种名录
import Resources from "../pages/search/news/resources"
import ResourcesEn from "../pages/en/search/news/resources"
import application from "../pages/en/search/application"
// const PartnerAgencies = () => import("../pages/PartnerAgencies.vue")
// 专利
import Patent from "../pages/search/patent"
import EnPatent from "../pages/en/search/patent"
import patentDetail from "../pages/search/patentDetail"
import EnpatentDetail from "../pages/en/search/patentDetail"
//最新解析
import newResolve from "../pages/search/newResolve"
import enNewResolve from "../pages/en/search/newResolve"
Vue.use(VueRouter)

const routes = [
    // 首页
    {
        path: '/',
        name: 'Main',
        component: Main,
    },
    {
        path: '/en',
        name: 'EnMain',
        component: EnMain,
    },
    {
        path: "/search/country",
        name: "country",
        component: country,
    },


    {
        path: "/search/search",
        name: "SearchList",
        component: SearchList,
    },
    {
        path: "/en/search/search",
        name: "SearchEnList",
        component: SearchEnList,
    },
    {
        path: "/search/newResolve",
        name: "newResolve",
        component: newResolve,
    },
    {
        path: "/en/search/newResolve",
        name: "enNewResolve",
        component: enNewResolve,
    },
    {
        path: "/search/cstrDetail",
        name: "Details",
        component: Details,
    },
    {
        path: "/en/search/application",
        name: "application",
        component: application,
    },

    {
        path: "/en/search/cstrDetail",
        name: "EnDetails",
        component: EnDetails,
    },
    {
        path: "/search/preprint",
        name: "Priprent",
        component: Priprent,
    },

    {
        path: "/en/search/preprint",
        name: "EnPriprent",
        component: EnPriprent,
    },
    {
        path: "/search/priprentDetail",
        name: "priprentDetail",
        component: priprentDetail,
    },

    {
        path: "/en/search/priprentDetailEn",
        name: "priprentDetailEn",
        component: priprentDetailEn,
    },
    {
        path: "/search/research",
        name: "NsfList",
        component: NsfList,
    },
    // NsfEnList
    {
        path: "/search/priList",
        name: "priList",
        component: priList,
    },
    {
        path: "/en/search/priList",
        name: "SearchEnPrilist",
        component: SearchEnPrilist,
    },

    {
        path: "/en/search/research",
        name: "NsfEnList",
        component: NsfEnList,
    },

    {
        path: "/search/meeting",
        name: "meeting",
        component: meeting => require(['@/pages/search/meeting'], meeting)
    },
    {
        path: "/en/search/meeting",
        name: "meeting",
        component: meeting => require(['@/pages/en/search/meeting'], meeting)
    },


    {
        path: "/search/member",
        name: "Member",
        component: Member => require(['@/pages/search/member'], Member)
    },
    {
        path: "/en/search/member",
        name: "enMember",
        component: enMember => require(['@/pages/en/search/member'], enMember)
    },
    {
        path: "/search/openApi",
        name: "openApi",
        component: openApi => require(['@/pages/search/openApi'], openApi)
    },
    {
        path: "/en/search/openApi",
        name: "enOpenApi",
        component: enOpenApi => require(['@/pages/en/search/openApi'], enOpenApi)
    },
    {
        path: "/search/notice",
        name: "Notice",
        component: Notice => require(['@/pages/search/notice'], Notice)
    },
    {
        path: "/en/search/message",
        name: "message",
        component: message => require(['@/pages/en/search/message'], message)
    },
    {
        path: "/en/search/notice",
        name: "Notice",
        component: Notice => require(['@/pages/en/search/notice'], Notice)
    },
    {
        path: "/search/newDatas",
        name: "newDatas",
        component: newDatas => require(['@/pages/search/newDatas'], newDatas)
    },
    {
        path: "/en/search/newDatas",
        name: "newDatas",
        component: newDatas => require(['@/pages/en/search/newDatas'], newDatas)
    },
    {
        path: "/search/newDetail",
        name: "newDetail",
        component: newDetail => require(['@/pages/search/newDetail'], newDetail)
    },
    {
        path: "/en/search/newDetail",
        name: "EnnewDetail",
        component: EnnewDetail => require(['@/pages/en/search/newDetail'], EnnewDetail)
    },
    // 学术论文详情
    {
        path: "/search/dissDetail",
        name: "dissDetail",
        component: dissDetail => require(['@/pages/search/dissDetail'], dissDetail)
    },
    {
        path: "/en/search/dissDetail",
        name: "EndissDetail",
        component: EndissDetail => require(['@/pages/en/search/dissDetail'], EndissDetail)
    },


    {
        path: "/search/parseQuote",
        name: "parseQuote",
        component: parseQuote => require(['@/pages/search/parseQuote'], parseQuote)
    },
    {
        path: "/en/search/parseQuote",
        name: "EnparseQuote",
        component: EnparseQuote => require(['@/pages/en/search/parseQuote'], EnparseQuote)
    },
    {
        path: "/search/newRegister",
        name: "newRegister",
        component: newRegister => require(['@/pages/search/newRegister'], newRegister)
    },
    {
        path: "/en/search/newRegister",
        name: "EnNewRegister",
        component: EnNewRegister => require(['@/pages/en/search/newRegister'], EnNewRegister)
    },


    {
        path: "/search/help",
        name: "help",
        component: help => require(['@/pages/search/help'], help)
    },
    {
        path: "/search/MostCited",
        name: "MostCited",
        component: MostCited => require(['@/pages/search/MostCited'], MostCited)
    },
    {
        path: "/en/search/MostCited",
        name: "EnMostCited",
        component: EnMostCited => require(['@/pages/en/search/MostCited'], EnMostCited)
    },
    {
        path: "/search/paper",
        name: "Paper",
        component: Paper,
    },
    {
        path: "/en/search/guide",
        name: "guideEn",
        component: guideEn => require(['@/pages/en/search/guide'], guideEn)
    },
    {
        path: "/en/search/paper",
        name: "PaperEn",
        component: PaperEn,
    },

    {
        path: "/search/guide",
        name: "guide",
        component: guide => require(['@/pages/search/guide'], guide)
    },

    {
        path: "/search/paperDetail",
        name: "paperDetail",
        component: paperDetail,
    },
    {
        path: "/en/search/paperDetail",
        name: "paperDetailEn",
        component: paperDetailEn,
    },
    // 重大基础设施
    {
        path: "/search/facilities",
        name: "facilities",
        component: facilities,
    },
    {
        path: "/en/search/facilities",
        name: "enFacilities",
        component: enFacilities,
    },
    // 种资资源
    {
        path: "/search/germaplasms",
        name: "germaplasms",
        component: germaplasms => require(['@/pages/search/germaplasms'], germaplasms)
    },
    {
        path: "/en/search/germaplasms",
        name: "enGermaplasms",
        component: enGermaplasms => require(['@/pages/en/search/germaplasms'], enGermaplasms)
    },
    {
        path: "/search/intro",
        name: "Intro",
        component: Intro => require(['@/pages/search/intro'], Intro)
    },
    {
        path: "/en/search/intro",
        name: "IntroEn",
        component: IntroEn => require(['@/pages/en/search/intro'], IntroEn)
    },
    //新闻列表
    {
        path: "/search/news/works",
        name: "NewList",
        component: NewList,
    },
    {
        path: "/en/search/news/works",
        name: "NewList",
        component: NewList,
    },
    {
        path: "/search/instrument",
        name: "instrument",
        component: instrument
    },
    {
        path: "/en/search/instrument",
        name: "enInstrument",
        component: enInstrument
    },
    // 物种资源
    {
        path: "/search/Resources",
        name: "Resources",
        component: Resources,
    },
    {
        path: "/en/search/resources",
        name: "ResourcesEn",
        component: ResourcesEn,
    },
    {
        path: "/search/resourceDetail",
        name: "resourceDetail",
        component: resourceDetail => require(['@/pages/search/resourceDetail'], resourceDetail)
    },
    {
        path: "/en/search/resourceDetail",
        name: "resourceDetail",
        component: resourceDetail => require(['@/pages/en/search/resourceDetail'], resourceDetail)
    },
    {
        path: "/search/patent",
        name: "Patent",
        component: Patent,
    },
    {
        path: "/en/search/EnPatent",
        name: "EnPatent",
        component: EnPatent,
    },
    {
        path: "/search/patentDetail",
        name: "patentDetail",
        component: patentDetail,
    },
    {
        path: "/en/search/EnPatentDetail",
        name: "EnpatentDetail",
        component: EnpatentDetail,
    },
    {
        path: "/search/prefix",
        name: "Prefix",
        component: Prefix => require(['@/pages/search/prefix'], Prefix)
    },
    {
        path: "/en/search/prefix",
        name: "EnPrefix",
        component: PrefixEn => require(['@/pages/en/search/prefix'], PrefixEn)
    },
    {
        path: "/search/institution",
        name: "institution",
        component: institution => require(['@/pages/search/institution'], institution)
    },
]
const router = new VueRouter({
    mode: 'history',
    //  base: '/sandbox/phone',
    base: '/phone',
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 }
        }
    },
})
export default router